import { render, staticRenderFns } from "./CatProp.vue?vue&type=template&id=0657e268&scoped=true"
import script from "./CatProp.vue?vue&type=script&lang=js"
export * from "./CatProp.vue?vue&type=script&lang=js"
import style0 from "./CatProp.vue?vue&type=style&index=0&id=0657e268&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0657e268",
  null
  
)

export default component.exports